import './App.css';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Fragment, Component } from 'react';
import Login from './components/Login';
import Navbar from './components/Navbar';
import './resources/global.css'
import Home from './components/Home';
import Register from './components/Register';
import userService from './services/userService';
import Posts from './components/Posts';
import UserContext from './contexts/UserContext';
import Logout from './components/Logout';
import Embed from './components/Embed';
import TermsOfUse from './components/TermsOfUse';
import PrivacyPolicy from './components/PrivacyPolicy';

class App extends Component {
  render() {
    const currentUser = userService.getCurrentUser()
    return (
      <Fragment>
        <UserContext.Provider value={{ isLoggedIn: !!currentUser, currentUser: currentUser?.sub }}>
          <Switch>
            <Route path="/embed/:id" exact component={Embed} />
            <>
              <Navbar />
              <div className="container" style={{
                paddingTop: !!currentUser ? 51 : 42
              }}>
                <Switch>
                <Route path="/logout" component={Logout} />
                <Route path="/login" component={Login} />
                <Route path="/register" component={Register} />
                <Route path="/tos" component={TermsOfUse} />
                <Route path="/privacy" component={PrivacyPolicy} />
                <Route path="/" render={(props) =>
                  currentUser ? <Posts {...props} /> : <Home {...props} />
                } />
                </Switch>
              </div>
            </>
          </Switch>
      </UserContext.Provider>
      </Fragment >
    );
  }
}

export default App;
